import { Event, Interface, Method } from '@central-products/transport-bus-common';
import {
  OnStateChangedCallback,
  OnUserRegisteredCallback,
  RegistrationFlowError,
  RegistrationFlowState,
  RegistrationFlowPayload,
} from './types';

@Interface('common', 'ui.registration.flow')
export class RegistrationFlowInterface {
  @Method('start')
  // @ts-ignore
  public start(payload: RegistrationFlowPayload): Promise<RegistrationFlowError> {
    throw new Error('Method is not implemented yet');
  }

  @Method('cancel')
  public cancel(): Promise<RegistrationFlowError> {
    throw new Error('Method is not implemented yet');
  }

  @Method('state.get')
  public getState(): Promise<RegistrationFlowState> {
    throw new Error('Method is not implemented yet');
  }

  @Event('state.changed')
  // @ts-ignore
  public onStateChanged(callback: OnStateChangedCallback): () => void {
    throw new Error('Event is not implemented yet');
  }

  @Event('user.registered')
  // @ts-ignore
  public onUserRegistered(callback: OnUserRegisteredCallback): () => void {
    throw new Error('Event is not implemented yet');
  }
}
